// Веб-вклад модуля `quizzes` — тесты.
//
// Роут исторический — `/tests` (алиас `tests` → `quizzes` живёт в
// `MODULE_ID_ALIASES`, переименование URL сюда не входит).
// `/tests/take` — полноэкранное прохождение поверх overlay-каркаса.

import { IconChecklist } from "@tabler/icons-react";
import {
	SECTION_CATEGORY,
	SECTION_ICONS,
	SECTION_TINT,
} from "@/components/navigation/section-icons";
import type { WebModuleManifest } from "./_contract";

export const quizzesWebManifest = {
	id: "quizzes",
	icon: SECTION_ICONS.tests,
	labelKey: "nav.tests",
	category: SECTION_CATEGORY.tests,
	routes: ["/tests"],
	overlayShellPrefixes: ["/tests/take"],

	// Баннер объясняет МЕХАНИКУ, которой не видно из названия: тест не
	// заканчивается баллом, из него сама собирается карта слабых мест, а
	// уверенность ответа влияет на её приоритет.
	intro: {
		titleKey: "quizzes:intro.title",
		bodyKey: "quizzes:intro.body",
		bulletKeys: ["quizzes:intro.bullets.0", "quizzes:intro.bullets.1", "quizzes:intro.bullets.2"],
	},

	nav: [
		{
			key: "quizzes",
			to: "/tests",
			icon: SECTION_ICONS.tests,
			labelKey: "nav.tests",
			order: 30,
			badge: {
				kind: "powersync",
				sql: "SELECT count(*) FROM tests WHERE user_id = ? AND deleted_at IS NULL",
			},
		},
	],

	launch: [
		{
			key: "quizzes",
			icon: SECTION_ICONS.tests,
			tint: SECTION_TINT.tests,
			titleKey: "launcher.quizzes",
			hintKey: "launcher.quizzesHint",
			to: "/tests",
			order: 100,
		},
	],

	workspaceTools: [
		{
			key: "moreQuiz",
			channel: "practice",
			icon: IconChecklist,
			steps: { 2: 20 },
			kitKind: "quiz",
		},
	],
} satisfies WebModuleManifest;
